import type { ReadonlyRefOrGetter } from '@vueuse/core';
import {  toValue, ref, watch, type Ref } from 'vue';

/**
 * Return a writable ref that automatically "open" based on the given reactive value.
 * It's mostly useful to controls modals or dropdowns that should open when a certain state is true,
 * and this **state is readonly** (closing the component cannot update the state).
 * @param stateToWatch - The state to watch to update if the component should be open or closed.
 * @returns A ref that indicates whether the component is open or closed.
 */
export function useAutoOpen(stateToWatch: ReadonlyRefOrGetter<unknown>): Ref<boolean> {
  const isOpen = ref(false);

  watch(
    () => toValue(stateToWatch),
    (newVal) => {
      const isTruthy = Boolean(newVal);
      isOpen.value = isTruthy;
    },
    { immediate: true },
  );

  return isOpen;
}